import { createSlice } from "@reduxjs/toolkit";
import { addUserGroup, addUserMember, associateServices,serviceUserGroup, UpdateServiceUserGroup, assoMemList, changeGroupStatus, deleteMember, deleteUserGrp, memberList, roleMenuService, userGroupGrid } from "../../actions/security/userGroupAction";

const initialState = {
    loading: false,
    groupTableData: null,
    error: null,
    success: false,
    //member list
    loading1: false,
    memberData: null,
    error1: null,
    success1: false,
    //add member
    loading2: false,
    addMemInfo: null,
    error2: null,
    success2: false,
    //associated member list
    loading3: false,
    associateMem: null,
    error3: null,
    success3: false,
    //add user group
    loading4: false,
    addGroupInfo: null,
    error4: null,
    success4: false,
    //rolemenu service
    loading5: false,
    roleMenuInfo: null,
    error5: null,
    success5: false,
    //change user group status
    loading6: false,
    grpStatusInfo: null,
    error6: null,
    success6: false,
    //associated services
    loading7: false,
    assSrvInfo: null,
    error7: null,
    success7: false,
    //delete member
    loading8: false,
    delMemInfo: null,
    error8: null,
    success8: false,
    //delete usergroup
    loading9: false,
    delGrpInfo: null,
    error9: null,
    success9: false,
    // user group service
    loading10 :false,
    grpSrvInfo : null,
    success10 : true,
    error10 : null,
    //update user group sevice
    loading11 : false,
    upGrpSrvInfo : null,
    success11 : true,
    error11 : null,
}

const userGrpSlice = createSlice({
    name: "user-account-mgmt",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(userGroupGrid.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(userGroupGrid.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.groupTableData = payload;
                state.success = true;
                state.error = null;
            })
            .addCase(userGroupGrid.rejected, (state, { paylaod }) => {
                state.loading = false;
                state.error = paylaod;
                state.success = false;
            })
            //member list
            .addCase(memberList.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(memberList.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.memberData = payload;
                state.success1 = true;
                state.error1 = null;
            })
            .addCase(memberList.rejected, (state, { paylaod }) => {
                state.loading1 = false;
                state.error1 = paylaod;
                state.success1 = false;
            })
            //add member
            .addCase(addUserMember.pending, (state) => {
                state.loading = true;
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(addUserMember.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.addMemInfo = payload;
                state.success2 = true;
                state.error2 = null;
            })
            .addCase(addUserMember.rejected, (state, { paylaod }) => {
                state.loading2 = false;
                state.error2 = paylaod;
                state.success2 = false;
            })
            //associated member list
            .addCase(assoMemList.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
            })
            .addCase(assoMemList.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.associateMem = payload;
                state.success3 = true;
                state.error3 = null;
            })
            .addCase(assoMemList.rejected, (state, { paylaod }) => {
                state.loading3 = false;
                state.error3 = paylaod;
                state.success3 = false;
            })
            //add user group
            .addCase(addUserGroup.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
            })
            .addCase(addUserGroup.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.addGroupInfo = payload;
                state.success4 = true;
                state.error4 = null;
            })
            .addCase(addUserGroup.rejected, (state, { paylaod }) => {
                state.loading4 = false;
                state.error4 = paylaod;
                state.success4 = false;
            })
            //role menu service
            .addCase(roleMenuService.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
            })
            .addCase(roleMenuService.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.roleMenuInfo = payload;
                state.success5 = true;
                state.error5 = null;
            })
            .addCase(roleMenuService.rejected, (state, { paylaod }) => {
                state.loading5 = false;
                state.error5 = paylaod;
                state.success5 = false;
            })
            //change user group status
            .addCase(changeGroupStatus.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
            })
            .addCase(changeGroupStatus.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.grpStatusInfo = payload;
                state.success6 = true;
                state.error6 = null;
            })
            .addCase(changeGroupStatus.rejected, (state, { paylaod }) => {
                state.loading6 = false;
                state.error6 = paylaod;
                state.success6 = false;
            })
            //associated Services
            .addCase(associateServices.pending, (state) => {
                state.loading7 = true;
                state.error7 = null;
                state.success7 = false;
            })
            .addCase(associateServices.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.assSrvInfo = payload;
                state.success7 = true;
                state.error7 = null;
            })
            .addCase(associateServices.rejected, (state, { paylaod }) => {
                state.loading7 = false;
                state.error7 = paylaod;
                state.success7 = false;
            })
            //delete member
            .addCase(deleteMember.pending, (state) => {
                state.loading8 = true;
                state.error8 = null;
                state.success8 = false;
            })
            .addCase(deleteMember.fulfilled, (state, { payload }) => {
                state.loading8 = false;
                state.delMemInfo = payload;
                state.success8 = true;
                state.error8 = null;
            })
            .addCase(deleteMember.rejected, (state, { paylaod }) => {
                state.loading8 = false;
                state.error8 = paylaod;
                state.success8 = false;
            })
            //delete userGroup
            .addCase(deleteUserGrp.pending, (state) => {
                state.loading9 = true;
                state.error9 = null;
                state.success9 = false;
            })
            .addCase(deleteUserGrp.fulfilled, (state, { payload }) => {
                state.loading9 = false;
                state.delGrpInfo = payload;
                state.success9 = true;
                state.error9 = null;
            })
            .addCase(deleteUserGrp.rejected, (state, { paylaod }) => {
                state.loading9 = false;
                state.error9 = paylaod;
                state.success9 = false;
            })
            //service user group
            .addCase(serviceUserGroup.pending, (state) => {
                state.loading10 = true;
                state.error10 = null;
                state.success10 = false;
            })
            .addCase(serviceUserGroup.fulfilled, (state, { payload }) => {
                state.loading10 = false;
                state.grpSrvInfo = payload;
                state.success10 = true;
                state.error10 = null;
            })
            .addCase(serviceUserGroup.rejected, (state, { paylaod }) => {
                state.loading10 = false;
                state.error10 = paylaod;
                state.success10 = false;
            })
             //update service user group
             .addCase(UpdateServiceUserGroup.pending, (state) => {
                state.loading11 = true;
                state.error11 = null;
                state.success11 = false;
            })
            .addCase(UpdateServiceUserGroup.fulfilled, (state, { payload }) => {
                state.loading11 = false;
                state.upGrpSrvInfo = payload;
                state.success11 = true;
                state.error11 = null;
            })
            .addCase(UpdateServiceUserGroup.rejected, (state, { paylaod }) => {
                state.loading11 = false;
                state.error11 = paylaod;
                state.success11 = false;
            })
    }
});

export default userGrpSlice.reducer;